import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import nmheader2 from "../nmheader2.png";
import Banner from "./Banner";

export default function Navigation() {
  const navigation = [
    { name: "Home", href: "/" },
    { name: "About", href: "/About" },
    { name: "Catering", href: "/Catering" },
    { name: "Meal Prep", href: "/Meal-Prep" },
    {
      name: "Products",
      href: "/Products",
      submenu: [
        { name: "Gift Box", href: "/Products/Gift-Box" },
        { name: "Soda Syrups", href: "/Products/Sodas" },
      ],
    },
    { name: "Events & Press", href: "/Events&Press" },
    { name: "Contact", href: "/Contact" },
  ];

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false); // desktop dropdown
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false); // mobile dropdown

  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <nav className="flex items-center justify-between p-1 lg:px-4" aria-label="Global">
        {/* Logo */}
        <div className="flex lg:flex-1">
          <a href="/" className="-m-1.5 p-0">
            <span className="sr-only">Natoncks Metsu</span>
            <img
              className="h-32 w-auto object-contain"
              src={nmheader2}
              alt="Natoncks Metsu Logo"
            />
          </a>
        </div>

        {/* Mobile menu button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400 hover:text-red"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6 mr-3" aria-hidden="true" />
          </button>
        </div>

       {/* Desktop Nav */}
<div className="hidden lg:flex lg:gap-x-10 lg:mr-4">
  {navigation.map((item) =>
    item.submenu ? (
      <div key={item.name} className="relative group">
        <button
          className="text-sm font-semibold leading-6 text-black hover:text-red inline-flex items-center"
        >
          {item.name}
          <ChevronDownIcon className="ml-1 h-4 w-4" />
        </button>

        {/* Dropdown Menu */}
        <div
          className="absolute left-0 top-full mt-0 w-44 rounded-md bg-white shadow-lg ring-1 ring-gray-200 
                     hidden group-hover:block"
        >
          {item.submenu.map((sub) => (
            <a
              key={sub.name}
              href={sub.href}
              className="block px-4 py-2 text-sm text-black hover:bg-gray-100"
            >
              {sub.name}
            </a>
          ))}
        </div>
      </div>
    ) : (
      <a
        key={item.name}
        href={item.href}
        className="text-sm hover:text-red font-semibold leading-6 text-black"
      >
        {item.name}
      </a>
    )
  )}
</div>

      </nav>

      <Banner />

      {/* Mobile Slide Menu */}
      <Dialog
        as="div"
        id="mobile"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-40" id="mobile-overlay" />

        <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full md:w-1/3 sm:max-w-sm overflow-y-auto bg-white px-6 py-6 shadow-lg sm:ring-1 sm:ring-red">
          {/* Stripe */}
          <div className="h-2 bg-red-500" />

          {/* Header with logo + close */}
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Natoncks Metsu</span>
              <img className="w-auto" src={nmheader2} alt="Natoncks Metsu logo" />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-400"
              onClick={() => setMobileMenuOpen(false)}
            >
              <XMarkIcon className="h-6 w-6 text-red" aria-hidden="true" />
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/25">
              <div className="space-y-2 py-6">
                {navigation.map((item) =>
                  item.submenu ? (
                    <div key={item.name} className="space-y-1">
                      <button
                        onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                        className="w-full flex items-center justify-between rounded-lg px-3 py-2 text-base font-semibold text-black hover:bg-gray-100"
                      >
                        {item.name}
                        <ChevronDownIcon
                          className={`h-4 w-4 transition-transform ${
                            mobileProductsOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                      {mobileProductsOpen && (
                        <div className="ml-4 space-y-1">
                          {item.submenu.map((sub) => (
                            <a
                              key={sub.name}
                              href={sub.href}
                              className="block rounded-lg px-3 py-2 text-sm text-black hover:bg-gray-100"
                            >
                              {sub.name}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <a
                      key={item.name}
                      href={item.href}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold text-black hover:bg-gray-100"
                    >
                      {item.name}
                    </a>
                  )
                )}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
}
